import React from 'react';

interface PlusProps {
  width?: number;
  color?: string;
}

const Plus = ({ width = 64, color = '#9498A7' }: PlusProps) => (
  <svg width={width} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="9.23071" y="6.1543" width="1.53846" height="8.46154" rx="0.769231" fill={color} />
    <rect
      x="14.2307"
      y="9.61523"
      width="1.53846"
      height="8.46154"
      rx="0.769231"
      transform="rotate(90 14.2307 9.61523)"
      fill={color}
    />
  </svg>
);

export default Plus;
